export default {
  header: { notes: 'Title', message: 'Geofence' },
  controls: {
    enable: {
      notes: 'Enable geofence button title',
      message: 'Enable geofence',
    },
    disable: {
      notes: 'Disable geofence button title',
      message: 'Disable geofence',
    },
    centerPoint: {
      header: {
        notes: 'Header for center point section',
        message: 'Center point',
      },
      point: {
        notes: ' Point on map button title',
        message: 'Point on map',
      },
      latest: {
        notes: 'Latest location button title',
        message: 'Use latest location',
      },
    },
    radius: {
      header: {
        notes: 'Radius control header',
        message: 'Radius',
      },
    },
    notification: {
      header: {
        notes: 'Notification header',
        message: 'Notification',
      },
      menuItems: {
        enter: { notes: 'On enter notification', message: 'On enter' },
        exit: { notes: 'On exit notification', message: 'On exit' },
      },
    },
    subscribers: {
      header: {
        notes: 'Subscribers header',
        message: 'Subscribers',
      },
      editButton: {
        notes: 'Edit subscribers list button title',
        message: 'Edit list',
      },
    },
    subscribeMe: {
      header: {
        notes: 'Subscribe me switch header',
        message: 'Subscribe me',
      },
    },
  },
  accuracy: {
    notes: 'Label for accuracy info in marker popup',
    message: 'Accuracy:',
  },
};
